import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/Home'
import HomeEN from '@/components/home-en/Home-en'
import nuestraEmpresa from '@/components/nuestra-empresa/nuestraEmpresa'
import nuestraEmpresaEN from '@/components/nuestra-empresa-en/nuestraEmpresa-en'
import nuestrosComienzos from '@/components/nuestros-comienzos/nuestrosComienzos'
import nuestrosComienzosEN from '@/components/nuestros-comienzos-en/nuestrosComienzos-en'
import Organizacion from '@/components/organizacion/Organizacion'
import OrganizacionEN from '@/components/organizacion-en/Organizacion-en'
import nuestrasPlantas from '@/components/nuestras-plantas/nuestrasPlantas'
import nuestrasPlantasEN from '@/components/nuestras-plantas-en/nuestrasPlantas-en'
import esquemaDelProceso from '@/components/esquema/esquemaDelProceso'
import esquemaDelProcesoEN from '@/components/esquema-en/esquemaDelProceso-en'
import medioAmbiente from '@/components/medio-ambiente/medioAmbiente'
import medioAmbienteEN from '@/components/medio-ambiente-en/medioAmbiente-en'
import sistemaDeGestion from '@/components/sistema-de-gestion/sistemaDeGestion'
import sistemaDeGestionEN from '@/components/sistema-de-gestion-en/sistemaDeGestion-en'
import relacionesInstitucionales from '@/components/relaciones-institucionales/relacionesInstitucionales'
import relacionesInstitucionalesEN from '@/components/relaciones-institucionales-en/relacionesInstitucionales-en'
import enviarCV from '@/components/enviar-cv/enviarCV'
import enviarCVEN from '@/components/enviar-cv-en/enviarCV-en'
import proveedores from '@/components/proveedores/proveedores'
import proveedoresEN from '@/components/proveedores-en/proveedores-en'
import contactenos from '@/components/contactenos/contactenos'
import contactenosEN from '@/components/contactenos-en/contactenos-en'
import lineaEtica from '@/components/linea-etica/lineaEtica'
import lineaEticaEN from '@/components/linea-etica-en/lineaEtica-en'
import quienesSomos from '@/components/quienes-somos/quienesSomos'
import quienesSomosEN from '@/components/quienes-somos-en/quienesSomos-en'
import ariba from '@/components/ariba/ariba'
import aribaEN from '@/components/ariba-en/ariba-en'
import regimen from '@/components/regimen/regimen'
import regimenEN from '@/components/regimen-en/regimen-en'
import info from '@/components/info/info'
import infoEN from '@/components/info-en/info-en'
import gobierno from '@/components/gobierno/gobierno'
import gobiernoEN from '@/components/gobierno-en/gobierno-en'
import contact from '@/components/contact/contact'
import contactEN from '@/components/contact-en/contact-en'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/home/',
      name: 'Home',
      component: Home
    },
    {
      path: '/home-en/',
      name: 'HomeEN',
      component: HomeEN
    },
    {
      path: '/nuestraEmpresa/',
      name: 'nuestraEmpresa',
      component: nuestraEmpresa
    },
    {
      path: '/nuestraEmpresa-en/',
      name: 'nuestraEmpresaEN',
      component: nuestraEmpresaEN
    },
    {
      path: '/nuestrosComienzos/',
      name: 'nuestrosComienzos',
      component: nuestrosComienzos
    },
    {
      path: '/nuestrosComienzos-en/',
      name: 'nuestrosComienzosEN',
      component: nuestrosComienzosEN
    },
    {
      path: '/organizacion/',
      name: 'Organizacion',
      component: Organizacion
    },
    {
      path: '/organizacion-en/',
      name: 'OrganizacionEN',
      component: OrganizacionEN
    },
    {
      path: '/nuestras-plantas/',
      name: 'nuestrasPlantas',
      component: nuestrasPlantas
    },
    {
      path: '/nuestras-plantas-en/',
      name: 'nuestrasPlantasEN',
      component: nuestrasPlantasEN
    },
    {
      path: '/esquema/',
      name: 'esquemaDelProceso',
      component: esquemaDelProceso
    },
    {
      path: '/esquema-en/',
      name: 'esquemaDelProcesoEN',
      component: esquemaDelProcesoEN
    },
    {
      path: '/medio-ambiente/',
      name: 'medioAmbiente',
      component: medioAmbiente
    },
    {
      path: '/medio-ambiente-en/',
      name: 'medioAmbienteEN',
      component: medioAmbienteEN
    },
    {
      path: '/sistema-de-gestion/',
      name: 'sistemaDeGestion',
      component: sistemaDeGestion
    },
    {
      path: '/sistema-de-gestion-en/',
      name: 'sistemaDeGestionEN',
      component: sistemaDeGestionEN
    },
    {
      path: '/relaciones-institucionales/',
      name: 'relacionesInstitucionales',
      component: relacionesInstitucionales
    },
    {
      path: '/relaciones-institucionales-en/',
      name: 'relacionesInstitucionalesEN',
      component: relacionesInstitucionalesEN
    },
    {
      path: '/enviar-cv/',
      name: 'enviarCV',
      component: enviarCV
    },
    {
      path: '/enviar-cv-en/',
      name: 'enviarCVEN',
      component: enviarCVEN
    },
    {
      path: '/contactenos/',
      name: 'contactenos',
      component: contactenos
    },
    {
      path: '/contactenos-en/',
      name: 'contactenosEN',
      component: contactenosEN
    },
    {
      path: '/linea-etica/',
      name: 'lineaEtica',
      component: lineaEtica
    },
    {
      path: '/linea-etica-en/',
      name: 'lineaEticaEN',
      component: lineaEticaEN
    },
    {
      path: '/quienes-somos/',
      name: 'quienesSomos',
      component: quienesSomos
    },
    {
      path: '/quienes-somos-en/',
      name: 'quienesSomosEN',
      component: quienesSomosEN
    },
    {
      path: '/ariba/',
      name: 'ariba',
      component: ariba
    },
    {
      path: '/ariba-en/',
      name: 'aribaEN',
      component: aribaEN
    },
    {
      path: '/proveedores/',
      name: 'proveedores',
      component: proveedores
    },
    {
      path: '/proveedores-en/',
      name: 'proveedoresEN',
      component: proveedoresEN
    },
    {
      path: '/regimen-oferta-publica/',
      name: 'regimen',
      component: regimen
    },
    {
      path: '/regimen-oferta-publica-en/',
      name: 'regimenEN',
      component: regimenEN
    },
    {
      path: '/informacion-financiera/',
      name: 'info',
      component: info
    },
    {
      path: '/informacion-financiera-en/',
      name: 'infoEN',
      component: infoEN
    },
    {
      path: '/gobierno-corporativo/',
      name: 'gobierno',
      component: gobierno
    },
    {
      path: '/gobierno-corporativo-en/',
      name: 'gobiernoEN',
      component: gobiernoEN
    },
    {
      path: '/contact/',
      name: 'contact',
      component: contact
    },
    {
      path: '/contact-en/',
      name: 'contactEN',
      component: contactEN
    },
    {
      path: '*',
      name: 'Default',
      component: Home
    }
  ],
  scrollBehavior: async function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    const findEl = async (hash, x = 0) => {
      return (
        document.querySelector(hash) ||
        new Promise(resolve => {
          if (x > 50) {
            return resolve(document.querySelector('#app'))
          }
          setTimeout(() => {
            resolve(findEl(hash, ++x || 1))
          }, 100)
        })
      )
    }
    if (to.hash) {
      let el = await findEl(to.hash)
      if ('scrollBehavior' in document.documentElement.style) {
        return window.scrollTo({ top: el.offsetTop, behavior: 'smooth' })
      } else {
        return window.scrollTo(0, el.offsetTop)
      }
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js